// React for Website

import React, { useState } from "react";
//outsource
import { Col, Input, Form, Button, Popover } from "antd";
import { CopyOutlined } from "@ant-design/icons";
//components

const VoucherLink = ({ href }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [open, setOpen] = useState(false);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const handleCopy = () => {
    navigator.clipboard.writeText(href);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item label="Purchase link">
      <Input
        placeholder="Please fill marketing Code"
        addonAfter={
          <Popover
            content={"Copied !"}
            trigger="click"
            open={open}
            onOpenChange={() => setOpen(true)}
          >
            <Button
              onClick={handleCopy}
              size="small"
              type="text"
              icon={<CopyOutlined />}
            />
          </Popover>
        }
        value={href}
        disabled={true}
      />
    </Form.Item>
  );
};

export default VoucherLink;
